// /sport-jackpot/get-all => OutTotoEntry[]
export interface OutTotoEntry{
    tournament: OutTotoTournament;
    prizes: OutTotoPrize[];
}
export interface OutTotoTournament {
    id: number,
    name: string,
    startDate: string,
    endDate: string,
    displayCurrency: string,
    displayCost: number,
    displayPrizePool: number,
    numEvents: number,
    bannerUrl: string,
    scommessa: number,
    marketName: string,
    description: string
}

export interface OutTotoPrize {
    numOdds: number, 
    minSelections: number, 
    displayPrize: number
}

// /sport-jackpot/get/:tournamentId => OutTotoTournamentMatches
export interface OutTotoTournamentMatches {
    totoTournamentId: number,
    matches: OutTotoTournamentMatch[],
    odds: Record<string, {
        name: string,
        marketName: string,
        market: number,
        outcome: number,
        value: number,
    }[]>
}

export interface OutTotoTournamentMatch {
    evento: number,
    home: string,
    away: string,
    time: string,
    settled: boolean,
    ftHome: string,
    ftAway: string,
    tournamentCode: string,
    categoryName: string,
    tournamentName: string
}

// /sport-jackpot/place TotoBetRequest => TotoTransaction
export interface TotoBetRequest {
    totoTournamentId: number,
    /**
     * "evento-scommessa-esito"
     */
    odds: string[]
}

// Serializzato in "evento-scommessa-esito"
export interface TotoSelection {
    evento: number,
    scommessa: number,
    esito: number
}

export interface TotoTransaction {
    ticketId: string,
    tx: {
        id: number,
        "transaction-id": string,
        "currency": string,
        "new-balance": number,
        "withdraw-id": string
    }
}

// /sport-jackpot/my-bets => OutUserBetList
export interface OutUserBetList {
    bets: OutUserBet[];
    matches: OutTotoTournamentMatch[];
    outcomes: OutcomeRow[]
}

export interface OutUserBet {
    id: number,
    tournamentId: number,
    time: string,
    status: TotoBetStatus,
    currency: String,
    stake: number,
    win: number,
    selections: TotoBetSelection[],
}

export enum TotoBetStatus {
	PENDING = "PENDING",
	WIN = "WIN",
	LOSE = "LOSE"
}

export interface TotoBetSelection {
    code: String,
    status: TotoOutcomeStatus,
}

export enum TotoOutcomeStatus {
	PENDING = "PENDING",
	WIN = "WIN",
	LOSE = "LOSE",
	VOID = "VOID"
}

export interface OutcomeRow {
    market: number,
    outcome: number,
    marketName: string,
    name: string,
}
